// extracted by mini-css-extract-plugin
export var checkIcon = "_g-2";
export var heading = "_g-1";
export var panel = "_g-0";